import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UTurnRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"u_turn_right"}/>
}
